<script>
  export default {
    name: "ToggleInput",
    props: {
      value: { type: Boolean, default: false },
      label: { type: String, default: "" },
      disabled: { type: Boolean, default: false },
    },
    methods: {
      toggle() {
        if (this.disabled) return;
        this.$emit("input", !this.value);
      },
    },
  };
</script>

<template>
  <div class="toggle" :class="{ 'toggle--disabled': disabled }" @click="toggle">
    <div class="toggle__track" :class="{ 'toggle__track--on': value }"></div>
    <span class="toggle__label" v-if="label">{{ label }}</span>
  </div>
</template>

<style lang="scss" scoped>
  .toggle {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 8px;

    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &__track {
      width: 40px;
      height: 20px;
      border-radius: 10px;
      background: #ccc;
      position: relative;
      transition: background 0.3s;

      &--on {
        background: #bd0909;
      }

      &::after {
        content: "";
        position: absolute;
        top: 3px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: linear-gradient(to bottom, #fff 0%, #fff 100%);
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s;
      }
    }

    &__track--on::after {
      transform: translateX(20px);
    }

    &__label {
      font-size: 14px;
      font-family: $newFont_regular;
    }
  }
</style>
